import Styles from './UploadsDrawer.module.scss'
import { MediaFile } from '../MediaFile'
import { useRootStore } from 'stores/RootStore'
import { useState } from 'react'
import { useDebounce } from 'hooks/useDebounce'
import { Text } from 'blaze-ui/Text/Text'
import { SearchInput } from './components/SearchInput'
import { useInsertStockVideos } from '../useInsertStockVideos'
import { useStockVideos } from 'hooks/queries/designer/useStockVideos'
import { getVideoMimeType } from '../components/StockVideosGallery'
import { IMediaFile } from '../Types'
import { Button } from 'blaze-ui/Button'

export const StockVideosPanel = () => {
  const [query, setQuery] = useState('')
  const debouncedQuery = useDebounce(query, 500)
  const { drawersStore } = useRootStore()
  const { handleInsert } = useInsertStockVideos()

  const { isLoading, data, error, hasNextPage, fetchNextPage } = useStockVideos({
    query: debouncedQuery,
    pageSize: 6,
    videoType: 'all',
  })
  const showNoResults = query.length > 0 && !isLoading && !data?.pages[0].videos.length

  const videos = data?.pages.flatMap((page) => page.videos) || []

  return (
    <div>
      <div className={Styles.sectionContainer}>
        <SearchInput value={query} onChange={setQuery} />
        {showNoResults && <Text variant="largeList">No results found for {query}.</Text>}
        {!!error && <Text variant="largeList">An error occurred while fetching videos.</Text>}
        <div className={Styles.groupItems}>
          {videos.map((video, index) => (
            <div key={index} className={Styles.mediaFileContainer}>
              <MediaFile
                key={video.id}
                src={video.videos.medium.thumbnail}
                file={
                  {
                    id: video.id,
                    source_url: video.videos.medium.url,
                    duration: video.duration,
                    variants: [],
                    mime_type: video.videos.medium.mime_type ?? getVideoMimeType(video.videos.medium.url),
                    title: video.id,
                  } as IMediaFile
                }
                onPress={() => {
                  handleInsert(video)
                  drawersStore.closeDrawer()
                }}
              />
            </div>
          ))}
        </div>
      </div>
      {!!debouncedQuery.length && hasNextPage && !isLoading && (
        <div className={Styles.seeMoreButton}>
          <Button fullWidth variant="tertiary" size="lg" onPress={() => fetchNextPage()}>
            See More
          </Button>
        </div>
      )}
    </div>
  )
}
